"use client";

import { ChakraProvider, defaultSystem } from "@chakra-ui/react";

import { ColorModeProvider } from "./color-mode";
import { Toaster } from "./toaster";

export function Provider(props: React.PropsWithChildren) {
  return (
    <ChakraProvider value={defaultSystem}>
      <ColorModeProvider>{props.children}</ColorModeProvider>
      <Toaster />
    </ChakraProvider>
  );
}
